<template>
  <div id="app56">
    <ExternalMeeting />
  </div>
</template>

<script>
import ExternalMeeting from "@/components/video-call/external-meeting-view/ExternalMeetingView.vue";

export default {
  name: "MeetingExternal",
  components: {
    ExternalMeeting
  },
  beforeMount() {
    console.log("Meeting External before mounting of it..");
  }
};
</script>

<style></style>
